import { z } from 'zod';

export const ReleaseNoteSchema = z.object({
  id: z.string().uuid(),
  tenantId: z.string().uuid(),
  releaseName: z.string(),
  releaseVersion: z.string(),
  releasedAt: z.string(),
  details: z.string().nullable(),
  active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type ReleaseNote = z.infer<typeof ReleaseNoteSchema>;

const ReleaseNoteBody = z.object({
  releaseName: z.string().min(1).max(200),
  releaseVersion: z.string().min(1).max(50),
  releasedAt: z.string(),
  details: z.string().nullable().optional(),
  active: z.boolean().optional(),
});

export const CreateReleaseNoteInput = ReleaseNoteBody;
export type CreateReleaseNoteInput = z.infer<typeof CreateReleaseNoteInput>;

export const PatchReleaseNoteInput = ReleaseNoteBody.partial();
export type PatchReleaseNoteInput = z.infer<typeof PatchReleaseNoteInput>;

export interface ListReleaseNotesQuery {
  q?: string;
  active?: boolean;
  sortField?: 'releaseName' | 'releaseVersion' | 'releasedAt' | 'createdAt' | 'updatedAt';
  sortDirection?: 'asc' | 'desc';
  limit?: number;
  offset?: number;
}
